import React from "react";

interface UseInfiniteScrollProps {
  hasMore: boolean;
  hasSearched?: boolean;
  onLoadMore: () => void;
  isLoading: boolean;
  threshold?: number;
}

export const useInfiniteScroll = ({
  hasMore,
  hasSearched = false,
  onLoadMore,
  isLoading,
  threshold = 100,
}: UseInfiniteScrollProps) => {
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (scrollHeight - scrollTop <= clientHeight + threshold) {
      if (hasMore && !isLoading) {
        onLoadMore();
      }
    }
  };

  return { handleScroll };
};
